/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ApiKeyScope = {
    ClaimsRead: 'claims:read',
    ClaimsWrite: 'claims:write',
    DocumentsRead: 'documents:read',
    DocumentsWrite: 'documents:write',
    PhotosRead: 'photos:read',
    PhotosWrite: 'photos:write',
    NotesRead: 'notes:read',
    NotesWrite: 'notes:write',
    TasksRead: 'tasks:read',
    TasksWrite: 'tasks:write',
    FormsRead: 'forms:read',
    FormsWrite: 'forms:write',
    LinksRead: 'links:read',
    LinksWrite: 'links:write',
    FinancialsRead: 'financials:read',
    FinancialsWrite: 'financials:write',
    ContactsRead: 'contacts:read',
    ContactsWrite: 'contacts:write',
    OrganizationsRead: 'organizations:read',
    OrganizationsWrite: 'organizations:write',
    PropertiesRead: 'properties:read',
    PropertiesWrite: 'properties:write',
    EmailsRead: 'emails:read',
    ActivityRead: 'activity:read',
    NotificationsRead: 'notifications:read',
    NotificationsWrite: 'notifications:write',
    ReportsRead: 'reports:read',
    ComparisonsRead: 'comparisons:read',
    SupplementsRead: 'supplements:read',
    EstimatesRead: 'estimates:read',
    WorkspaceRead: 'workspace:read',
    WorkspaceWrite: 'workspace:write'
} as const;
export type ApiKeyScope = typeof ApiKeyScope[keyof typeof ApiKeyScope];


export function instanceOfApiKeyScope(value: any): boolean {
    for (const key in ApiKeyScope) {
        if (Object.prototype.hasOwnProperty.call(ApiKeyScope, key)) {
            if (ApiKeyScope[key as keyof typeof ApiKeyScope] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiKeyScopeFromJSON(json: any): ApiKeyScope {
    return ApiKeyScopeFromJSONTyped(json, false);
}

export function ApiKeyScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyScope {
    return json as ApiKeyScope;
}

export function ApiKeyScopeToJSON(value?: ApiKeyScope | null): any {
    return value as any;
}

export function ApiKeyScopeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiKeyScope {
    return value as ApiKeyScope;
}

